import "./CColors.css";

import React from "react";
import ThemeIcon from "../components/custom-icons/ThemeIcon";

const colors = [
  "primary",
  "primary-light",
  "primary-lighter",
  "primary-lightest",
  "primary-dark",
  "primary-darker",
  "primary-darkest",
  "color-background",
  "color-background-light",
  "color-background-lighter",
  "color-background-dark",
  "color-background-darker",
  "color-background-darkest",

  "color-test",
];

export default function Colors() {
  return (
    <div className="color-page">
      <ThemeIcon />
      <div className="color-grid">
        {colors.map((color) => (
          <div key={color}>
            <div className={`color-box ${color}`}></div>
            <div className="color-name">{color}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
